export default __webpack_public_path__ + "images/bxb_daa748.svg";